import React, { useContext, useState } from 'react'
import { Link } from 'react-router-dom'
import { menuItemsData } from './menuItemsData'
import MenuItems from './MenuItems'
import './Navbar.css';
import { UserContext } from './App';

function Navbar() {

  const { state, dispatch } = useContext(UserContext);
  const [dropdown, setDropdown] = useState(true)

  {/*
  function OpenDropdown() {
    alert('open')
    setDropdown(true)
  }
*/}

  const RenderMenu = () => {
    if (state) {
      return (
        <>
          <nav className='flex justify-between bg-[#1a1a1a] item-center border-b' >
            <div className='text-white p-10 text-4x'>ADS Hospital</div>
           
            <ul className='text-white hidden md:flex gap-6 list-none'>
              {menuItemsData.map((menu, index) => {
                return (
                  <MenuItems items={menu} key={index} />
                )

              })}
            </ul>
          </nav>
        </>
      )
    }
    else {
      return (
        <>
        <nav className='flex justify-between p-5 bg-[#1a1a1a] item-center border-b'>
          <div className='text-white text-4x'>ADS Hospital</div>
          <div className='text-white hidden md:flex gap-6'>
            <Link className='menu' to={'/'}>Home</Link>
            <Link className='menu' to={'/Login'}>Login</Link>
          </div>
        </nav>
        </>
      )
    }
  }

  return (
    <>
      <RenderMenu />
    </>
  )
}

export default Navbar
